export default __webpack_public_path__ + "static/circles-58895abe877cb778911db87b8e65e4a1.svg";